<script>
    import {FormSubmitted} from '../store';
    export let btnTitle = 'Proceed';
    export let JoinAs;
    let temp = '61%';
    let emailAdd;
    let proceed = false;
    let showdiv = false;
    let show = true;
    let isDisabled = false;
    $: console.log('JoinAs mobile', JoinAs);

    /**
     */
    async function saveData() {
        isDisabled = true;
        const functionUrl =
            'https://us-central1-opusai.cloudfunctions.net/updateWorkSheet';
        await fetch(functionUrl, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                data: [emailAdd, JoinAs],
            }),
        }).then((res) => {
            if (res.status === 401) {
                proceed = false;
                showdiv.style.display = 'block';
                isDisabled = false;
            } else if (res.status === 200) {
                show = false;
                FormSubmitted.update((n) => true);
                proceed = true;
                showdiv.style.display = 'none';
            }
        });
    }
    if ($FormSubmitted) {
        proceed = true;
    }
    $: {
        if (proceed === true) {
            temp = '59%';
        }
    }
</script>


<div role="presentation" class="box" on:click/>
    <div class="boxWrraperInner">
        {#if proceed === false}
            <div class="secondBox" style="">
                <p>
                    <span
                        style="font-size:3.271vw;font-weight: 900;margin-bottom:1.168vw;line-height:5.103vw;"
                    >
                        We're not ready yet :(
                    </span> <br />Join our waitlist
                </p>
                <div style="margin-top: 8.178vw;">
                    <form on:submit|preventDefault={saveData}>
                        <div class="input-field">
                            <input
                                bind:value={emailAdd}
                                type="email"
                                required
                                placeholder="Enter your Email..."
                            />
                        </div>
                        <div class="error-div" bind:this={showdiv}>
                            <p style=" color: red; font-size: 0.5vw;">
                                Please Enter Vaild Email
                            </p>
                        </div>
                        <div class="btn">
                            <button type="submit" disabled={isDisabled}
                                >{btnTitle}</button
                            >
                        </div>
                    </form>
                </div>
            </div>
        {:else if proceed === true}
            <div class="thankyou-box">
                <p class="thankyou-text1">
                    Awesome! Thanks for submitting your email.
                </p>
                <p class="thankyou-text2">
                    We'll notify you as we roll out invites in the coming weeks!
                </p>
                <h1 class="shareit">Share it on</h1>
                <div class="logoWrraper">
                    <div class="imgwrraper">
                        <a
                            href="https://twitter.com/intent/tweet?text=I%20just%20signed%20up%20for%20Opus%27%20waitlist.%20Opus%20is%20a%20text-to-videogames%20platform.%20join%20the%20wait%20list%20at%20opus.ai%20%23OpusAI"
                            target="_blank"
                        >
                            <img
                                src="/images/team/twiter.svg"
                                alt="twitter"
                                width="100%"
                                height="100%"
                            />
                        </a>
                    </div>
                    <div class="imgwrraper">
                        <a
                            href="https://www.linkedin.com/sharing/share-offsite/?url=opus.ai"
                            target="_blank"
                        >
                            <img
                                src="/images/team/linkden.svg"
                                alt="linkden"
                                width="100%"
                                height="100%"
                            />
                        </a>
                    </div>
                    <div class="imgwrraper">
                        <a
                            href="https://www.facebook.com/sharer/sharer.php?u=opus.ai"
                            target="_blank"
                        >
                            <img
                                src="/images/team/facebook.svg"
                                alt="facebook"
                                width="100%"
                                height="100%"
                            />
                        </a>
                    </div>
                    <div class="imgwrraper">
                        <a
                            href="https://vk.com/share.php?url=opus.ai"
                            target="_blank"
                        >
                            <img
                                src="/images/team/vk.svg"
                                alt="VK"
                                width="100%"
                                height="100%"
                            />
                        </a>
                    </div>
                </div>
            </div>
        {/if}
        <div class="close-btn" style="top: {temp}">
            <p role="presentation" class="cancelBtn" on:click>close</p>
        </div>
    </div>
<!-- </div> -->

<style>
    .shareit{
        text-align: center;
        font-family: "Orbitron";
        font-size: 3.271vw;
        font-weight: 900;
        margin-top: 8vw;
        margin-bottom: 4.168vw;
        color: #ff007f;
    }
    .logoWrraper{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 6vw;
    }
    .logoWrraper .imgwrraper{
        height: 13vw;
        width: 13vw;
        margin-right: 2vw;
    }
    .error-div {
        margin-top: -6vw;
        margin-left: -34.7vw;
        margin-bottom: -0.8vw;
        display: none;
    }
    .input-field {
        margin-top: 1vw;
    }
    .thankyou-box {
        width: 80vw;
        height: auto;
        background-color: white;
        border: .1vw solid #ff007f;
        margin-left: auto;
        margin-right: auto;
    }
    .thankyou-box .thankyou-text1 {
        padding-top: 1.2vw;
        color: black;
        font-family: "Orbitron";
        text-align: center;
        font-size: 3.271vw;
        font-weight: 900;
    }
    .thankyou-box .thankyou-text2 {
        color: black;
        font-size: 2.671vw;
        font-weight: 400;
        font-family: "Orbitron";
        text-align: center;
    }
    .secondBox {
        width: 68.224vw;
        height: 55.14vw;
        background-color: white;
        margin: auto;
    }
    .cancelBtn {
        color: white;
        font-size: 4.673vw;
        font-weight: 400;
        margin-top: 1.667vw;
        font-family: "Orbitron";
        position: relative;
        z-index: 12;
        cursor: pointer;
    }
    .box {
        width: 100%;
        background: rgba(0, 0, 0, 0.8);
        height: 100%;
        text-align: center;
        position: fixed;
        top: 0vw;
        z-index: 10;
        left: 0vw;
    }
    .boxWrraperInner{
        top: 50%;
        left: 50%;
        z-index: 11;
        text-align: center;
        position: fixed;
        transform: translate(-50%, -50%);
    }
    .secondBox p {
        font-size: 3.271vw;
        font-weight: 500;
        width: fit-content;
        margin: auto;
        color: black;
        padding-top: 6.71vw;
        text-align: center;
        font-family: "Orbitron";
        line-height: 4.103vw;
    }
    .secondBox button {
        font-family: "Orbitron";
        width: 56.308vw;
        height: 10.047vw;
        background-color: #ff007f;
        color: white;
        border: none;
        font-size: 2.336vw;
        font-weight: 800;
        cursor: pointer;
    }
    .secondBox input {
        font-family: "Orbitron";
        width: 56.308vw;
        height: 10.047vw;
        color: rgb(0, 0, 0);
        border: 0.052vw solid #b2b2b2;
        font-size: 2.336vw;
        font-weight: 400;
        padding-left: 4.661vw;
        box-sizing: border-box;
    }
    .secondBox button:hover {
        font-family: "Orbitron";
        width: 16.094vw;
        height: 2.083vw;
        background-color: black;
        color: white;
        border: none;
        font-size: 0.625vw;
        font-weight: 800;
        transition-duration: 1s;
        cursor: pointer;
    }
    .btn {
        margin-top: 2.336vw;
    }
    ::placeholder {
        font-size: 2.336vw;
        color: black;
        font-weight: 400;
    }
</style>
